import { dayjs } from "@lib";
import { useQuery } from "@tanstack/react-query";
import { getExpensesRanking } from "../services";
import type {
	ExpensesByVehicleFilters,
	ExpensesRankingResponseApi,
} from "../types";

const initialData: ExpensesRankingResponseApi = {
	header: {
		fleetTotalCurrentMonth: 0,
		averagePerVehicleCurrentMonth: 0,
		outOfPatternCount: 0,
		attentionCount: 0,
		totalVehicles: 0,
		vehiclesWithExpensesCurrentMonth: 0,
		year: dayjs().year(),
		month: dayjs().month() + 1,
	},
	vehicles: {
		items: [],
		totalCount: 0,
		pageSize: 10,
		currentPage: 1,
		totalPages: 1,
	},
};
export function useGetExpensesRanking(filters: ExpensesByVehicleFilters) {
	return useQuery({
		queryKey: ["expenses", "ranking", filters],
		queryFn: () => getExpensesRanking(filters),
		initialData,
	});
}
